import {Canton, Commune, Prefecture, Region, StatutJuridique, TypeStructure} from '../../parametre/parametre.model';
import {CandNotif} from '../../candidat/models/candidat.model';

export interface Evaluation {
    id: number
    etat: string
    idMotifDecision: any
    dateDecision: any
    structure_id: number
    created_at: string
    updated_at: string
}

export class ContactStructure {
    id: any
    civilite: string
    nom: string
    prenoms: string
    titre: string
    typeContact: string
    telMobile: string
    email: string
    structure_id?: number
    created_at?: string
    updated_at?: string
}

export class StructureResister {
    sigle:                 string;
    raisonSociale:         string;
    user_id:               number;
    idTypeStructure:       number;
    idStatutJuridique:     number;
    idRegionResidence:     number;
    idPrefectureResidence: number;
    idCommuneResidence:    number;
    idCanton:              number;
    telMobile:             string;
    contact:               ContactStructure[];
}

export class Structure {
    id: number
    sigle: string
    raisonSociale: string
    etat?: string
    user_id: number
    id_structure_core?: number
    idTypeStructure: number
    idStatutJuridique: number
    idRegionResidence: number
    idPrefectureResidence: number
    idCommuneResidence: number
    idCanton: number
    telMobile1: string
    telMobile2: string
    profil_is_valide?: boolean

    created_at: string
    updated_at: string
    region: Region
    canton: Canton
    prefecture: Prefecture
    commune: Commune
    typeStructure: TypeStructure
    struct_notif: StructNotif
    statutJuridique: StatutJuridique
    evaluation: Evaluation
    contacts: ContactStructure[]

    constructor(){
        this.region = new Region();
        this.prefecture = new Prefecture();
        this.commune = new Commune();
        this.canton = new Canton();

        this.typeStructure = new TypeStructure();
        this.statutJuridique = new StatutJuridique();
    }
}

export class StructNotif {
    id: number
    telephone_fixe: string
    email: string
    candidat_id: number
    created_at: string
    updated_at: string
}